import {createAsyncThunk} from '@reduxjs/toolkit';
import HttpClient from '../../api/api';
import {VisibleDays} from '../report/types';
import {TimeReportV2DailyReport, TimeReportV2Item} from './types';

type GetTimeReportV2Args = {
    from: string;
    to: string;
    employeeIds: number[];
    projectIds: number[];
    projectTypeIds: number[];
    showAbsences: boolean;
};

type GetTimeReportV2DailyArgs = GetTimeReportV2Args & {
    visibleDays: VisibleDays;
};

export const getTimeReportV2 = createAsyncThunk<TimeReportV2Item[], GetTimeReportV2Args>(
    'time-report-v2/get',
    async (args) => {
        const response = await HttpClient.timeReportV2Api.get<TimeReportV2Item[]>(
            args.from,
            args.to,
            args.employeeIds,
            args.projectIds,
            args.projectTypeIds,
            args.showAbsences
        );
        return response.data;
    }
);

export const getTimeReportV2Daily = createAsyncThunk<TimeReportV2DailyReport, GetTimeReportV2DailyArgs>(
    'time-report-v2/get-daily',
    async (args) => {
        const response = await HttpClient.timeReportV2Api.getDaily<TimeReportV2DailyReport>(
            args.from,
            args.to,
            args.employeeIds,
            args.projectIds,
            args.projectTypeIds,
            args.visibleDays,
            args.showAbsences
        );
        return response.data;
    }
);
